import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MaterialTooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  popper: {
    zIndex: 950
  },
  tooltip: {
    ...theme.typography.subtitle1,
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    borderRadius: theme.shape.borderRadius * 2,
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },
  secondary: {
    background: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText
  },
  arrow: {
    color: theme.palette.primary.main
  },
  arrowSecondary: {
    color: theme.palette.secondary.main
  }
}));

const Tooltip = ({
  tooltipClass,
  open,
  arrow,
  secondary,
  title,
  placement,
  children
}) => {
  const classes = useStyles();

  return (
    children && (
      <MaterialTooltip
        classes={{
          popper: classes.popper,
          tooltip: classNames(
            classes.tooltip,
            secondary && classes.secondary,
            tooltipClass
          ),
          arrow: classNames(classes.arrow, secondary && classes.arrowSecondary)
        }}
        open={open}
        arrow={arrow}
        title={title}
        placement={placement}
      >
        {children}
      </MaterialTooltip>
    )
  );
};

Tooltip.propTypes = {
  open: PropTypes.bool,
  arrow: PropTypes.bool,
  secondary: PropTypes.bool,
  title: PropTypes.node,
  placement: PropTypes.string,
  children: PropTypes.node
};

export default Tooltip;
